import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AccessibilityNewOutlinedIcon from '@mui/icons-material/AccessibilityNewOutlined';
import NatureOutlinedIcon from '@mui/icons-material/NatureOutlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
import CardGiftcardOutlinedIcon from '@mui/icons-material/CardGiftcardOutlined';

export const navigationLinks = {
  mainNav: [
    { id: 'home', icon: HomeOutlinedIcon, text: 'Home', url: '/' },
    { id: 'blog', icon: ArticleOutlinedIcon, text: 'Blog', url: '/blog' }
  ],
  orderInfo: [
    { id: 'howToOrder', icon: HelpOutlineOutlinedIcon, text: 'How to Order', url: '/how-to-order' },
    { id: 'deliveryInfo', icon: LocalShippingOutlinedIcon, text: 'Delivery Information', url: '/delivery-info' },
    { id: 'bankingDetails', icon: AccountBalanceOutlinedIcon, text: 'Banking Details', url: '/banking-details' },
    { id: 'returnPolicy', icon: AssignmentReturnOutlinedIcon, text: 'Returns', url: '/return-policy' }
  ],
  account: {
    guest: [
      { id: 'login', icon: LoginOutlinedIcon, text: 'Sign In', url: '/login' },
      { id: 'register', icon: PersonAddOutlinedIcon, text: 'Register', url: '/register' },
      { id: 'forgotPassword', icon: LockOutlinedIcon, text: 'Reset Password', url: '/forgot-password' }
    ],
    authenticated: [
      { id: 'profile', icon: PersonOutlineOutlinedIcon, text: 'Profile', url: '/account/profile' },
      { id: 'orders', icon: HistoryOutlinedIcon, text: 'Orders', url: '/shop/orders' },
      { id: 'changeEmail', icon: EmailOutlinedIcon, text: 'Change Email', url: '/account/change-email' },
      { id: 'changePassword', icon: LockOutlinedIcon, text: 'Change Password', url: '/account/change-password' },
      { id: 'logout', icon: LogoutOutlinedIcon, text: 'Logout', url: '/logout' }
    ]
  },
  common: [
    { id: 'basket', icon: ShoppingBasketOutlinedIcon, text: 'Basket', url: '/shop/basket' },
  ],
  help: [
    { id: 'faq', icon: QuestionAnswerOutlinedIcon, text: 'FAQ', url: '/support/faq' },
    { id: 'makeReturn', icon: AssignmentReturnOutlinedIcon, text: 'Returns', url: '/support/make-a-return' }
  ],
  more: [
    { id: 'aboutUs', icon: InfoOutlinedIcon, text: 'About Us', url: '/about-us' },
    { id: 'contact', icon: PhoneOutlinedIcon, text: 'Contact Us', url: '/contact' }
  ]
};
